/**
 * @generated SignedSource<<9f047303fe04bbc73a1d8ef23757cc2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteeRelationship = "MANAGER" | "SUBORDINATE" | "TEAMMATE";
export type InviteMeetingUsersMutationInput = {
  analytics: string;
  captchaToken: string;
  clientMutationId?: string | null;
  eventId: string;
  invitations: ReadonlyArray<InviteUserInput | null>;
};
export type InviteUserInput = {
  email: string;
  fullName: string;
  oneOnOneDetails?: InviteOneOnOneInput | null;
  relationship?: InviteeRelationship | null;
  sendInviteEmail?: boolean | null;
};
export type InviteOneOnOneInput = {
  eventEnd?: string | null;
  eventId?: string | null;
  eventStart?: string | null;
};
export type MeetingInviteUsersMutation$variables = {
  input: InviteMeetingUsersMutationInput;
};
export type MeetingInviteUsersMutation$data = {
  readonly inviteMeetingUsers: {
    readonly event: {
      readonly attendees: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string | null;
        readonly image: string | null;
        readonly invitable: boolean;
        readonly user: {
          readonly id: string;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isGuest: boolean;
        } | null;
      } | null>;
      readonly id: string;
    } | null;
    readonly invitees: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly field: string | null;
        readonly message: string;
      } | null> | null;
      readonly user: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isActive: boolean;
        readonly isConfigured: boolean;
        readonly isGuest: boolean;
      } | null;
    }>;
  } | null;
};
export type MeetingInviteUsersMutation = {
  response: MeetingInviteUsersMutation$data;
  variables: MeetingInviteUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteMeetingUsersMutationPayload",
    "kind": "LinkedField",
    "name": "inviteMeetingUsers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InviteUserOutput",
        "kind": "LinkedField",
        "name": "invitees",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Attendee",
            "kind": "LinkedField",
            "name": "attendees",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invitable",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingInviteUsersMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingInviteUsersMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "2e5b51688b53cd06d4ef41d3ab973986",
    "id": null,
    "metadata": {},
    "name": "MeetingInviteUsersMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingInviteUsersMutation(\n  $input: InviteMeetingUsersMutationInput!\n) {\n  inviteMeetingUsers(input: $input) {\n    invitees {\n      errors {\n        field\n        message\n      }\n      user {\n        id\n        email\n        image\n        fullName\n        isActive\n        isConfigured\n        isGuest\n      }\n    }\n    event {\n      id\n      attendees {\n        invitable\n        email\n        fullName\n        image\n        user {\n          id\n          isActive\n          isConfigured\n          isGuest\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "85bf8d644ea5faab3db8952268eca54a";

export default node;
